import { all, takeLatest, put, fork, call } from 'redux-saga/effects';
import actions from './actions';
import * as reOrderParagraphServices from '@iso/services/reading/reOrderParagraph';

//#region CRUD
export function* getReOrderParagraph() {
	yield takeLatest(actions.GET_REORDER_PARAGRAPH, function* ({ payload }) {
		const { model } = payload;
		try {
			var response = yield call(reOrderParagraphServices.getAPIReOrderParagraph, model);
			if (response.data.success === true) {
				var data = response.data.data.data;
				var totalItems = response.data.data.total;
				yield put({
					type: actions.GET_REORDER_PARAGRAPH_SUCCESS,
					payload: { data, totalItems },
				});
			}
		} catch (e) {
			yield put({
				type: actions.READING_LOADING_FALSE,
			});
		}
	});
}

export function* getReOrderParagraphDetail() {
	yield takeLatest(actions.GET_REORDER_PARAGRAPH_DETAIL, function* ({ payload }) {
		const { id } = payload;
		try {
			var response = yield call(reOrderParagraphServices.getAPIReOrderParagraphDetail, id);
			if (response.data.success === true) {
				var data = response.data.data;
				yield put({
					type: actions.GET_REORDER_PARAGRAPH_DETAIL_SUCCESS,
					payload: { data },
				});
			}
		} catch (e) {
			yield put({
				type: actions.READING_LOADING_FALSE,
			});
		}
	});
}

// export function* getReadAloudDetail() {
// 	yield takeLatest(actions.GET_READ_ALOUD_DETAIL, function* ({ payload }) {
// 		const { id } = payload;
// 		try {
// 			var response = yield call(blanksDropDownServices.getReadAloudDetail, id);
// 			if (response.data.success === true) {
// 				var data = response.data.data;
// 				yield put({
// 					type: actions.GET_DROP_DOWN_DETAIL_SUCCESS,
// 					payload: { data },
// 				});
// 			}
// 		} catch (e) {
// 			yield put({
// 				type: actions.READING_LOADING_FALSE,
// 			});
// 		}
// 	});
// }

// export function* createQuesReadAloud() {
// 	yield takeLatest(actions.CREATE_NEW_DROP_DOWN, function* ({ payload, cbSuccess, cbError }) {
// 		const { model } = payload;
// 		try {
// 			var response = yield call(blanksDropDownServices.createQuesReadAloud, model);
// 			if (response.data.success === true) {
// 				yield cbSuccess();
// 			}
// 		} catch (e) {
// 			if (e.response && e.response.data) yield cbError(e.response.data.ErrorMessage);
// 			else yield cbError();
// 		}
// 	});
// }

// export function* updateReadAloudDetail() {
// 	yield takeLatest(actions.UPDATE_DROP_DOWN_DETAIL, function* ({ payload, cbSuccess, cbError }) {
// 		const { model } = payload;
// 		try {
// 			var response = yield call(blanksDropDownServices.updateReadAloudDetail, model);
// 			if (response.data.success === true) {
// 				yield cbSuccess();
// 			}
// 		} catch (e) {
// 			if (e.response && e.response.data) yield cbError(e.response.data.ErrorMessage);
// 			else yield cbError();
// 		}
// 	});
// }

// export function* deleteReadAloud() {
// 	yield takeLatest(actions.DELETE_DROP_DOWN, function* ({ payload, cbSuccess, cbError }) {
// 		const { id } = payload;
// 		try {
// 			var response = yield call(blanksDropDownServices.deleteReadAloud, id);
// 			if (response.data.success === true) {
// 				yield cbSuccess();
// 			}
// 		} catch (e) {
// 			if (e.response && e.response.data) yield cbError(e.response.data.ErrorMessage);
// 			else yield cbError();
// 		}
// 	});
// }

// export default function* rootSaga() {
// 	yield all([fork(getReOrderParagraph), fork(getReadAloudDetail), fork(createQuesReadAloud), fork(updateReadAloudDetail), fork(deleteReadAloud)]);
// }

export default function* rootSaga() {
	yield all([fork(getReOrderParagraph), fork(getReOrderParagraphDetail)]);
}
